import toast from 'react-hot-toast';

/**
 * Custom toast utilities that ensure only one toast is visible at a time
 */

export const customToast = {
  success: (message: string, options?: any) => {
    toast.dismiss();
    return toast.success(message, options);
  },
  error: (message: string, options?: any) => {
    toast.dismiss();
    return toast.error(message, options);
  },
  loading: (message: string, options?: any) => {
    toast.dismiss();
    return toast.loading(message, options);
  },
  custom: (message: any, options?: any) => {
    toast.dismiss();
    return toast.custom(message, options);
  },
  promise: toast.promise, // Keep promise as-is since it manages its own state
  dismiss: toast.dismiss,
};

export default customToast;
